<div class="flex">
    <!-- Show the tree -->
    <div class="box">
        <h2 class="tabTitle">Arbre des vérifications</h2>
        <ng-container *ngIf="rootOfTree">
            <app-arbre-component [composant]="rootOfTree" [forEdition]=false  (composantEvent)='selectComposant($event)' [showAll]="false"></app-arbre-component>
        </ng-container>
    </div>
    <!-- Show the current verification -->
    <div class="box2" *ngIf="selectedComposant">
        <app-current-verif (changeComposant)='selectComposant($event)' (resetMachine)='resetSelectedMachine($event)' *ngIf="selectedComposant" [subTree]="subTree" [snMachine]="snMachine"></app-current-verif>
    </div>
</div>

